var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4026 1.80684C10.9096 1.94895 11.3921 2.14976 11.8422 2.4015L13.3055 1.60442L15.1637 3.44539L14.3675 4.89954C14.6358 5.36715 14.8487 5.87055 14.9975 6.4008L16.5932 6.88013L16.5919 9.4959L15.0094 9.94967C14.8612 10.4921 14.6459 11.0068 14.373 11.4843L15.148 12.9068L13.3071 14.7652L11.8681 13.9774C11.4109 14.2358 10.92 14.4415 10.4035 14.5864L9.92265 16.1937L7.30687 16.1953L6.84631 14.5958C6.30536 14.4472 5.79203 14.2319 5.31575 13.9592L3.8436 14.7652L2.00273 12.9068L2.80967 11.4256C2.55379 10.9671 2.35072 10.4751 2.20869 9.95779L0.597794 9.4959L0.596436 6.88012L2.22079 6.39218C2.3632 5.8871 2.56391 5.40647 2.8152 4.95799L1.98696 3.44539L3.84523 1.60442L5.34163 2.41953C5.81038 2.15395 6.31464 1.94376 6.84552 1.79787L7.30796 0.197144L9.92373 0.200994L10.4026 1.80684ZM12.146 8.19688C12.146 10.1607 10.554 11.7527 8.59021 11.7527C6.62639 11.7527 5.0344 10.1607 5.0344 8.19688C5.0344 6.23306 6.62639 4.64108 8.59021 4.64108C10.554 4.64108 12.146 6.23306 12.146 8.19688Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/gear.560443166ffe987d1c6e5140b34b65b8.svg";
export { ForwardRef as ReactComponent };